import React from "react";

const NPS = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M18 2c8.837 0 16 7.163 16 16s-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2Zm7.354 8.646a.952.952 0 0 0-1.221-.107c-4.624 3.245-7.232 5.168-7.83 5.763a2.404 2.404 0 0 0 0 3.396 2.404 2.404 0 0 0 3.395 0c.35-.352 2.268-2.962 5.756-7.836a.943.943 0 0 0-.1-1.216ZM26.8 16.4a1.6 1.6 0 1 0 .001 3.201A1.6 1.6 0 0 0 26.8 16.4Zm-17.6 0a1.6 1.6 0 1 0 .001 3.201A1.6 1.6 0 0 0 9.2 16.4Zm3.709-5.754a1.601 1.601 0 0 0-2.263 0 1.601 1.601 0 0 0 0 2.263 1.601 1.601 0 0 0 2.263 0 1.601 1.601 0 0 0 0-2.263ZM18 7.6a1.6 1.6 0 1 0 .001 3.201A1.6 1.6 0 0 0 18 7.6Z"
            fill={fill}
        />
    </svg>
);

export default NPS;


